import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { FusionStats, ProjectManagerOption } from '@ps/survey-utils';

export const SurveyManagementActions = createActionGroup({
  source: 'Survey Management',
  events: {
    'Assign Buyer Project Manager': props<{
      surveyId: number;
      projectManager: ProjectManagerOption;
    }>(),
    'Remove Buyer Project Manager': props<{ surveyId: number }>(),
    'Assign Operator Project Manager': props<{
      surveyId: number;
      projectManager: ProjectManagerOption;
    }>(),
    'Remove Operator Project Manager': props<{ surveyId: number }>(),
    'Create Price Block': props<{ surveyId: number }>(),
    'Reset Fusion Block Stats': props<{ surveyId: number }>(),
    'Load Fusion Stats': props<{ surveyId: number }>(),
    'Reset Fusion Stats Panel': emptyProps(),
  },
});

export const SurveyManagementApiActions = createActionGroup({
  source: 'Survey Management API',
  events: {
    'Assign Buyer Project Manager Success': props<{
      surveyId: number;
      projectManager: ProjectManagerOption;
    }>(),
    'Assign Buyer Project Manager Failure': props<{ error: string }>(),
    'Remove Buyer Project Manager Success': props<{ surveyId: number }>(),
    'Remove Buyer Project Manager Failure': props<{ error: string }>(),
    'Assign Operator Project Manager Success': props<{
      surveyId: number;
      projectManager: ProjectManagerOption;
    }>(),
    'Assign Operator Project Manager Failure': props<{ error: string }>(),
    'Remove Operator Project Manager Success': props<{ surveyId: number }>(),
    'Remove Operator Project Manager Failure': props<{ error: string }>(),
    'Create Price Block Success': props<{ message: string }>(),
    'Create Price Block Failure': props<{ error: string }>(),
    'Reset Fusion Block Stats Success': props<{ message: string }>(),
    'Reset Fusion Block Stats Failure': props<{ error: string }>(),
    'Load Fusion Stats Success': props<{ stats: FusionStats }>(),
    'Load Fusion Stats Failure': props<{ error: string }>(),
  },
});
